import Components from './components';

export default {
  Components,
};
